import * as React from 'react';
import b_ from 'b_';
import MoneyView from 'shared/components/MoneyView';
import { Money } from 'shared/types/common';

import './index.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  children?: Money | null;
}

const b = b_.with('position-details-footer-factoid');

export const Factoid: React.FC<Props> = ({ title, children, ...props }) => (
  <div className={b()} {...props}>
    <div className={b('title')} data-testid="title">
      {title}
    </div>
    <div className={b('value')}>
      <MoneyView cents data-testid="value">
        {children}
      </MoneyView>
    </div>
  </div>
);
